module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_shooting-01b1ee5ea30320560b69e0225463deac.jpg";